import { Alert, Button, Center, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { IconShieldLock, IconTool } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useLogout } from '@/api/session';
import { Logo } from '@/components/Logo';
import { SecuritySection } from '@/features/profile/SecuritySection';
import { WorkspaceSwitcher } from '@/features/workspace/WorkspaceSwitcher';

/** Workspace verlangt 2FA (SEC-03): nur die Einrichtung ist möglich. */
export function TwoFactorRequiredPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const logout = useLogout();
  return (
    <Center mih="100dvh" p="md">
      <Stack maw={640} w="100%">
        <Group justify="space-between">
          <Logo />
          <Group>
            <WorkspaceSwitcher />
            <Button variant="subtle" onClick={() => logout.mutate(undefined, { onSettled: () => navigate('/login') })}>
              {t('header.logout')}
            </Button>
          </Group>
        </Group>
        <Alert color="orange" icon={<IconShieldLock size={20} />} title={t('gates.twoFactorTitle')}>
          {t('gates.twoFactorText')}
        </Alert>
        <SecuritySection />
      </Stack>
    </Center>
  );
}

/** Wartungsmodus (SYS-05) für Nicht-Super-Admins. */
export function MaintenancePage({ message }: { message: string }) {
  const { t } = useTranslation();
  return (
    <Center mih="100dvh" p="md">
      <Paper withBorder p="xl" maw={520}>
        <Stack align="center" ta="center">
          <IconTool size={40} />
          <Title order={3}>{t('gates.maintenanceTitle')}</Title>
          <Text>{message}</Text>
          <Button variant="default" onClick={() => window.location.reload()}>
            {t('gates.reload')}
          </Button>
        </Stack>
      </Paper>
    </Center>
  );
}
